import React from 'react';
import moment from 'moment';
import 'moment/locale/da'; // Danish (DK)
import 'moment/locale/de';
import 'moment/locale/de-at';
import 'moment/locale/de-ch';
import 'moment/locale/en-au';
import 'moment/locale/en-ie';
import 'moment/locale/en-gb';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/es-us';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/fr-ch';
import 'moment/locale/it';
import 'moment/locale/it-ch';
import 'moment/locale/ja'; // Japanese (JP)
import 'moment/locale/nb'; // Norwegian (NB)
import 'moment/locale/nl';
import 'moment/locale/nl-be';
import 'moment/locale/pt';
import 'moment/locale/se';
import Router from 'src/Router';
import { currentCulture } from 'src/utils/cultureUtil';

moment.locale(currentCulture);

const App: React.FC = () => {
  return <Router />;
};

export default App;
